import React from 'react';
import { enterprise } from '../../data/portfolioData';

const AI_CAPABILITIES = [
  { label: "RAG Pipelines", detail: "Ingestion · Embeddings · Vector Search" },
  { label: "Hybrid AI Systems", detail: "Heuristics + LLM Inference" },
  { label: "AI-powered Chat", detail: "Structured Output · Quality Eval" },
  { label: "Scheduled Pipelines", detail: "Cloud Scheduler · Batch Analysis" },
  { label: "Cloud Infrastructure", detail: "GCP · Cloud Run · Pub/Sub" },
];

export default function Enterprise() {
  return (
    <section className="section" id="enterprise">
      <div className="container">
        <div className="section-head reveal">
          <div>
            <div className="section-tag">Enterprise Experience</div>
            <h2>AI systems and cloud infrastructure at scale.</h2>
          </div>
          <p className="section-desc">
            Private and client work building AI infrastructure, RAG pipelines and backend services on Google Cloud.
          </p>
        </div>

        <div className="ent-capabilities reveal">
          {AI_CAPABILITIES.map(c => (
            <div key={c.label} className="ent-cap">
              <div className="ent-cap-dot" aria-hidden="true" />
              <div>
                <div className="ent-cap-label">{c.label}</div>
                <div className="ent-cap-detail">{c.detail}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="enterprise-list reveal">
          {enterprise.map((e, i) => (
            <div key={i} className="exp-row">
              <div className="exp-company">
                <div className="exp-logo" aria-hidden="true">{e.initials}</div>
                <div>
                  <div className="exp-name">{e.company}</div>
                  <div className="exp-role">{e.role}</div>
                </div>
              </div>
              <div className="exp-impact">{e.impact}</div>
              <div className="exp-stack">
                {e.stack.map(s => <span key={s} className="chip">{s}</span>)}
              </div>
              <div className="exp-dates">
                <div>{e.dates}</div>
                {e.private && <span className="private-badge">NDA</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
